import { Link } from 'react-router-dom';
import { Section, RuleList } from '../ui';

export default function Products() {
  return (
    <main>
      <Section lg>
        <span className="eyebrow">Products &amp; Innovation</span>
        <h1 className="h-page" style={{ maxWidth: '20ch' }}>
          Built for the problems we ran into.
        </h1>
        <p className="lede">
          Wanda Analytics applies AI and operational expertise to develop new solutions for
          real-world challenges — starting with the ones our own flight teams hit first.
        </p>
      </Section>

      <Section>
        <div className="split">
          <div>
            <div className="badge">
              <i />
              <span>Patent pending</span>
            </div>
            <h2 className="h-sec" style={{ fontSize: 'clamp(30px, 3.6vw, 44px)', marginBottom: 16 }}>
              DroneClear
            </h2>
            <p className="body" style={{ fontSize: 16, maxWidth: '48ch', marginBottom: 28 }}>
              DroneClear gives organizations the confidence to scale drone operations by connecting
              qualifications, authorizations, aircraft, approvals, and flight evidence in one clear
              system.
            </p>
            <RuleList
              items={[
                'Airspace and approval workflows',
                'Pilot, aircraft, and currency records',
                'Mission scheduling across sites and regions',
                'Audit-ready operational history'
              ]}
            />
          </div>
          {/* The wordmark is navy-on-light artwork, so it sits on its own light
              plate rather than being recoloured to suit this palette. */}
          <div className="plate">
            <img
              src="/assets/droneclear-logo.png"
              alt="DroneClear — confidence, standardized"
              loading="lazy"
            />
          </div>
        </div>
      </Section>

      <Section alt>
        <div style={{ maxWidth: '60ch', marginBottom: 36 }}>
          <span className="eyebrow">How the pipeline fits together</span>
          <h2 className="h-sub" style={{ margin: '16px 0 12px' }}>
            From imagery to operational AI
          </h2>
          <p className="body" style={{ fontSize: 16 }}>
            Define, prepare, build, evaluate, integrate, and improve — the loop every Wanda program
            runs on.
          </p>
        </div>
        <div className="scroll-x">
          <img
            src="/assets/process-diagram.png"
            alt="Wanda Analytics pipeline: define requirements, prepare and annotate training data, build models and computer vision, evaluate performance and validation, integrate applications and workflows, and feed back continuous improvement"
            loading="lazy"
          />
        </div>
      </Section>

      <Section>
        <h2 className="h-sub" style={{ marginBottom: 20 }}>
          Working on something harder?
        </h2>
        <p className="body" style={{ fontSize: 16, maxWidth: '52ch', marginBottom: 28 }}>
          We take on custom development where an operational problem does not have a product behind
          it yet.
        </p>
        <Link className="btn btn--primary" to="/contact">
          Start a conversation
        </Link>
      </Section>
    </main>
  );
}
